import * as _ from 'lodash'
import * as Model from '../types/document'


export function callOutputNodeId(callId: Model.CallId, graph: Model.Graph): Model.NodeId {
  return graph.calls[callId].outputs[0].outside
}

export function graphTrunkNodeId(graph: Model.Graph): Model.NodeId {
  let nodeId = _.find(graph.nodes)!.id  // !?: Every graph contains at least one node
  let nextNodeId
  while (nextNodeId = stepToTrunk(graph, nodeId)) {
    nodeId = nextNodeId
  }
  return nodeId
}

function stepToTrunk(graph: Model.Graph, nodeId: Model.NodeId): Model.NodeId | undefined {
  const maybeCall = _.find(graph.calls, (call) =>
    _.some(call.inputs, (input) => input.outside === nodeId)
  )
  return maybeCall && maybeCall.outputs[0].outside
}


// WEBPACK FOOTER //
// ./src/model/graph.ts